import { UnitStateData } from '@mark43/cad-api';
import { useMemo } from 'react';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';

export function useUnitStateTransitions(statusId: number | undefined): UnitStateData[] {
    const { unitStateDataById } = useBootstrapState();

    return useMemo(() => {
        if (!statusId) {
            return [];
        }
        const currentUnitStateData = unitStateDataById[statusId];
        if (currentUnitStateData) {
            return currentUnitStateData.transitionToUnitStateIds.map((id) => unitStateDataById[id]);
        } else {
            return [];
        }
    }, [unitStateDataById, statusId]);
}
